import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=045620c8&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=ts"
export * from "./SearchBar.vue?vue&type=script&lang=ts"
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=045620c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045620c8",
  null
  
)

export default component.exports